import { EngagementDataModel } from './engagement-data.model';
import { LinkedinDataModel } from './linkedin-data-model';
import { RedditDataModel } from './reddit-data.model';
import { TiktokDataModel } from './tiktok-data.model';
import { TweetDataModel } from './tweet-data.model';
import { YoutubeDataModel } from './youtube-data.model';
import { BlueskyData } from './bluesky-data.model';

export class MentionSocialDataModel {
    engagementLastFetchedDate: number;
    handle: string;
    tweetData: TweetDataModel;
    username: string;
    engagementData: EngagementDataModel[];
    avatarUrl: string;
    redditData: RedditDataModel;
    youtubeData: YoutubeDataModel;
    tiktokData: TiktokDataModel;
    linkedinData: LinkedinDataModel;
    blueskyData: BlueskyData;
}
